import { render, staticRenderFns } from "./comments-dialog.vue?vue&type=template&id=577d4efe&scoped=true"
import script from "./comments-dialog.vue?vue&type=script&lang=js"
export * from "./comments-dialog.vue?vue&type=script&lang=js"
import style0 from "./comments-dialog.vue?vue&type=style&index=0&id=577d4efe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d4efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577d4efe')) {
      api.createRecord('577d4efe', component.options)
    } else {
      api.reload('577d4efe', component.options)
    }
    module.hot.accept("./comments-dialog.vue?vue&type=template&id=577d4efe&scoped=true", function () {
      api.rerender('577d4efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/entries/components/comments-dialog.vue"
export default component.exports